<template>
    <div class="mak-musteri-makina-list">
        <v-banner class="heading font-weight-medium text-left">
            <div class="pa-2">Müşteri Makina Listesi</div>
        </v-banner>

        <v-data-table
            :items="list"
            :headers="headers"
            :expanded="expanded"
            :disable-pagination="true"
            item-key="id"
            show-expand
            single-expand
            hide-default-footer
        >

            <template v-slot:item.makina_adi="{ item }">
                <img
                    :src="resimler[item.renk]"
                    style="width: 25px; height: auto"
                />
            </template>

            <template v-slot:expanded-item="{ item, headers }">
                <td :colspan="headers.length">
                    <v-row class="pa-6 d-flex flex-column align-start">
                        <p><b>Başlangıç Zamanı:</b> {{item.baslangic}}</p>
                        <p><b>Calışma Başlangıc Saati:</b> {{item.calisma_baslangic_saati}}</p>
                        <p><b>Calışma Bitis Saati:</b> {{item.calisma_bitis_saati}}</p>
                        <p><b>Calışma Günleri:</b> {{ gunler(item.calisma_gunleri) }}</p>
                        <p><b>Kontrol Zamanı:</b> {{item.kontrol}}</p>
                        <p><b>Yoğunluk:</b> {{item.yogunluk}}</p>
                        <p><b>Tutar:</b> {{item.tutar}}</p>
                        <p><b>Not:</b> {{item.not}}</p>
                        <div class="d-flex justify-space-between align-center w-100">
                            <div class="font-weight-bold">
                                Fotoğraflar:
                            </div>
                            <div>
                                <v-btn
                                    color="deep-purple accent-2"
                                    class="w-100" dark
                                    @click="openUpload(item.id)"
                                >
                                    <v-icon left>mdi-cloud-upload</v-icon>
                                    Fotoğraf Yükle
                                </v-btn>
                                <br>
                                <v-btn
                                    v-if="false"
                                    icon="el-icon-camera-solid"
                                    class="w-100"
                                    @click="openCamera(item.id)">
                                    Fotoğraf çek
                                </v-btn>
                            </div>
                        </div>
                        <makina-fotos :makina-id="item.id"/>
                    </v-row>
                </td>
            </template>

        </v-data-table>

        <div v-if="selectedMakinaId">
            <mak-camera v-model="camera" :makina-id="selectedMakinaId"/>
            <mak-upload v-model="upload" :makina-id="selectedMakinaId"/>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import MakCamera from '@/components/MakCamera.vue'
    import MakUpload from '@/components/MakUpload.vue'
    import MakinaFotos from '@/components/MakinaFotos.vue'
    import { resimler } from '@/common/kokular.js';

    export default {
        name: 'mak-musteri-makina-list',
        props: {
            musteriId: {type: [String, Number], required: true},
            photoUpload: {type: Boolean, default: false},
            loading: { type: Boolean, default: false },
        },
        components: {
            MakCamera,
            MakUpload,
            MakinaFotos,
        },
        data() {
            return {
                expanded: [],
                camera: false,
                upload: false,
                selectedMakinaId: null,
                list: [],
                resimler,
                headers: [
                    { text: 'Makina', value: 'makina_adi' },
                    { text: 'Koku', value: 'koku_adi' },
                    { text: 'Koku ml', value: 'koku_ml' },
                ],
            };
        },
        methods: {
            fetch() {
                this.$emit('update:loading', true);
                this.$requests.MusteriMakina
                    .getMusteriMakinaByMusteriId(this.musteriId)
                    .then((data) => {
                        this.list = data
                            .map((d) => {
                                d.baslangic = moment(d.baslangic_zamani).format('DD/MM/YYYY HH:mm');
                                d.kontrol = `Her ayın ${moment(d.baslangic_zamani).get('date')}`;
                                return d;
                            });
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.$emit('update:loading', false);
                    });
            },
            gunler(vals) {
                const gun = ['Pazartesi', 'Salı', 'Carşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'];
                return vals.split(',').map(v => gun[v - 1]).join(',');
            },

            openUpload(makina_id) {
                this.camera = false;
                this.upload = true;
                this.selectedMakinaId = makina_id;
            },
            openCamera(makina_id) {
                this.upload = false;
                this.camera = true;
                this.selectedMakinaId = makina_id;
            },
        },
        mounted() {
            this.fetch();
        },
    }
</script>
